export default __webpack_public_path__ + "static/media/auto.abc9f744.jpg";